import React from 'react';
import "./App.scss";
import { AppRoutes } from "./routes";

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
